import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "count", "idsInput", "downloadLabel", "toggleAllBtn"]

  connect() {
    this.updateUI()
  }

  onToggle() {
    this.updateUI()
  }

  toggleAll() {
    const allChecked = this.checkboxTargets.every(cb => cb.checked)
    this.checkboxTargets.forEach(cb => { cb.checked = !allChecked })
    this.updateUI()
  }

  updateUI() {
    const selected = this.checkboxTargets.filter(cb => cb.checked).map(cb => cb.value)
    const total = this.checkboxTargets.length

    this.countTarget.textContent = selected.length > 0
      ? `${selected.length} selected`
      : `${total} photos`

    this.downloadLabelTarget.textContent = selected.length > 0
      ? `Download (${selected.length})`
      : `Download all (${total})`

    this.idsInputTarget.value = selected.join(',')

    this.toggleAllBtnTarget.textContent = selected.length === total && total > 0
      ? 'Clear'
      : 'Select all'
  }
}
